import React from 'react';
import { Scale } from 'lucide-react';

const Legal = () => {
  return (
    <div className="bg-black min-h-screen text-gray-300 pt-20 px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center mb-12">
          <Scale className="w-16 h-16 mr-6 text-white" />
          <h1 className="text-5xl font-bold text-white tracking-tight">
            Open Source License
          </h1>
        </div>

        <div className="space-y-12">
          <div className="bg-gray-900 p-6 rounded-lg">
            <p className="text-lg leading-relaxed">
              ContextUI is open source software licensed under the Apache License, Version 2.0.
              The source code is available at{' '}
              <a
                href="https://github.com/contextui-desktop/contextui"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300"
              >
                github.com/contextui-desktop/contextui
              </a>.
            </p>
          </div>

          <section className="border-l-4 border-white pl-6">
            <h2 className="text-3xl font-semibold text-white mb-6">Apache License, Version 2.0</h2>

            <div className="bg-gray-900 p-6 rounded-lg font-mono text-sm leading-relaxed whitespace-pre-wrap">
{`Copyright 2025 Intelligent System Design Pty Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.`}
            </div>

            <div className="mt-8 space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-white mb-2">What this means</h3>
                <p className="text-lg leading-relaxed">
                  The Apache 2.0 license is a permissive open source license that allows you to:
                </p>
                <ul className="list-disc pl-6 space-y-2 mt-4">
                  <li>Use the software for any purpose, including commercial use</li>
                  <li>Modify the source code and create derivative works</li>
                  <li>Distribute copies of the original or modified software</li>
                  <li>Grant a sublicense to modify and distribute the software to third parties</li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-white mb-2">Requirements</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Include a copy of the Apache 2.0 license in any redistribution</li>
                  <li>Provide clear attribution to the original project</li>
                  <li>State any significant changes made to the software</li>
                  <li>Include any existing NOTICE file contents with distributions</li>
                </ul>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-white mb-2">Trademarks</h3>
                <p className="text-lg leading-relaxed">
                  The Apache 2.0 license does not grant permission to use the trade names, trademarks,
                  service marks, or product names of Intelligent System Design Pty Ltd, except as
                  required for reasonable and customary use in describing the origin of the work.
                </p>
              </div>
            </div>
          </section>

          <section className="border-l-4 border-white pl-6">
            <h2 className="text-3xl font-semibold text-white mb-6">Full License Text</h2>
            <p className="text-lg leading-relaxed">
              The full text of the Apache License 2.0 is available at{' '}
              <a
                href="http://www.apache.org/licenses/LICENSE-2.0"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300"
              >
                www.apache.org/licenses/LICENSE-2.0
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Legal;
